(function (globals) {

    "use strict";

    BrandsPredefinedSetSaveModalController.$inject = ["$scope", "modalData", "brandsPredefinedSetsService"];
    function BrandsPredefinedSetSaveModalController($scope, modalData, brandsPredefinedSetsService) {

        var self = this;

        self.saveActions = {
          OVERWRITE: 'OVERWRITE',
          SAVE_AS_NEW: 'SAVE_AS_NEW'
        };

        self.loading = false;
        self.saveAction = self.saveActions.SAVE_AS_NEW;
        self.setToOverwrite = null;
        self.name = '';
        self.sets = modalData.predefinedSets || [];

        self.close = function () {
            if (self.loading) {
                return ;
            }
            $scope.$hide();
        };

        self.save = function () {

            var method;

            if (self.saveAction === self.saveActions.SAVE_AS_NEW) {
                method = brandsPredefinedSetsService.createPredefinedSet(modalData.groupId, self.name, modalData.brands);
            }
            else if (self.saveAction === self.saveActions.OVERWRITE) {
                method = brandsPredefinedSetsService.updatePredefinedSet(modalData.groupId, self.setToOverwrite.id, self.setToOverwrite.title, modalData.brands);
            }

            self.loading = true;

            method
                .then(function (result) {
                    modalData.onChange();
                    $scope.$hide();
                })
                .catch(function (err) {

                })
                .finally(function () {
                    self.loading = false;
                })

        };

        self.validForm = function () {
            return (self.saveAction === self.saveActions.SAVE_AS_NEW && self.name !== '') ||
                (self.saveAction === self.saveActions.OVERWRITE && self.setToOverwrite)
        }
    }

    globals.getBrandsPredefinedSetSaveModal = function (modalData) {
        return {
            controller: BrandsPredefinedSetSaveModalController,
            controllerAs: '$ctrl',
            templateUrl: '../hmodules/brands-predefined-sets/modals/brands-predefined-set-save/brands-predefined-set-save.modal.html',
            show: true,
            backdrop: 'static',
            resolve: {
                modalData: modalData
            }
        };
    };

})(window);

